import { router } from "@/main";
import { authService } from "@/services";
import { EventBus } from "@/helpers";
import { getField, updateField } from "vuex-map-fields";
import { USER_TYPE, dateOptions } from "@/const";
import { i18n } from "@/main";

export const auth = {
  namespaced: true,

  state: {
    loggedOn: false,
    // single source of data
    firstname: "",
    lastname: "",
    email: "",
    newsletter: false,
    activated: false,
    usertype: "",
    phone: "",
    airport_id: "",
    company: "",
    street: "",
    city: "",
    province: "",
    postalcode: "",

    card_brand: "",
    card_expire_month: "",
    card_expire_year: "",
    card_last4: "",

    plan_type: "",
    cancelled: "",
    coupon_used: "",
    plan_freq: "",
    quantity: 0,
    pilot_network: "",

    registered_on: "",
    current_period_start: "",
    current_period_end: "",
    current_period_start_date: "",
    current_period_end_date: "",

    // flight review address
    review_street: "",
    review_city: "",
    review_province: "",
    review_postalcode: "",
    flight_schools: []
  },
  actions: {
    // asynchronous operations
    signup(context, user) {
      return authService
        .signup(user)
        .then(response => {
          console.log(response);
          if (response.data.status !== "success") {
            EventBus.$emit("failedSignup", i18n.t(response.data.error));
          }

          return response.data;
        })
        .catch(error => {
          console.log("Error signup: ", error);
          EventBus.$emit("failedSignup: ", error);
        });
    },
    logon(context, user) {
      return authService
        .logon(user)
        .then(response => {
          console.log(response);
          if (response.data.logon) {
            context.commit("logon");
            let user = JSON.parse(response.data.user);
            if (user.usertype === USER_TYPE.AIRPORT) {
              router.push("/airportmap");
            } else {
              const query = router.history.current.query
              if (query && query.loginSuccessTargetPage) {
                router.push(query.loginSuccessTargetPage);
              } else {
                router.push("/dashboard");
              }
            }
          } else {
            EventBus.$emit("failedLogon", response.data.error);
          }
        })
        .catch(error => {
          console.log("Error logon: ", error);
          EventBus.$emit("failedLogon", error);
        });
    },
    refreshToken(context) {
      return authService
        .refreshToken()
        .then(response => {
          console.log(response);
          if (response.data.refresh) {
            let user = JSON.parse(response.data.user);
            if (user.usertype === USER_TYPE.AIRPORT) {
              router.push("/airportmap");
            } else {
              router.push("/dashboard");
            }
          } else {
            context.commit("logout");
            router.push("/");
          }
        })
        .catch(error => {
          console.log("Error refreshToken: ", error);
          context.commit("logout");
          router.push("/");
        });
    },
    logout(context) {
      return authService
        .logout()
        .then(response => {
          console.log(response);
          if (response.data.logout) {
            context.commit("logout");
            router.push("/");
          }
        })
        .catch(error => {
          console.log("Error logout: ", error);
          EventBus.$emit("failedLogout", error);
        });
    },
    sendMessage(context, message) {
      return authService
        .sendMessage(message)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error sendMessage: ", error);
          EventBus.$emit("failedSendMessage", error);
        });
    },
    sendEmails(context, payload) {
      return authService
        .sendEmails(payload)
        .then(response => {
          console.log(response);
          if (response.data.status !== "success") {
            EventBus.$emit("failedSendEmails", i18n.t(response.data.error));
          }

          return response.data;
        })
        .catch(error => {
          console.log("Error sendEmails: ", error);
          EventBus.$emit("failedSendEmails", error);
        });
    },
    sendEmailsToAll(context, payload) {
      return authService
        .sendEmailsToAll(payload)
        .then(response => {
          console.log(response);
          if (response.data.status !== "success") {
            EventBus.$emit(
              "failedSendEmailsToAll",
              i18n.t(response.data.error)
            );
          }

          return response.data;
        })
        .catch(error => {
          console.log("Error sendEmails: ", error);
          EventBus.$emit("failedSendEmailsToAll", error);
        });
    },
    getEmailTemplates() {
      return authService
        .getEmailTemplates()
        .then(response => {
          if (response.data.error) {
            EventBus.$emit(
              "failedGetEmailTemplate",
              i18n.t(response.data.error)
            );
          }

          return response.data;
        })
        .catch(error => {
          console.log("Error getEmailTemplate: ", error);
          EventBus.$emit("failedGetEmailTemplate", error);
        });
    },
    getUserProfile(context) {
      return authService
        .getUserProfile()
        .then(response => {
          console.log(response);
          context.commit("setUserProfile", {
            response
          });
        })
        .catch(error => {
          console.log("Error getUserProfile", error);
        });
    },
    editUserProfile(context) {
      return authService
        .editUserProfile(context.state)
        .then(response => {
          console.log(response);
          if (response.data !== null) {
            EventBus.$emit("updatedUserProfile");
          }
        })
        .catch(error => {
          console.log("Error editUserProfile: ", error);
          EventBus.$emit("failedEditUserProfile", error);
        });
    },
    resetPassword(context, email, password) {
      return authService
        .resetPassword(email, password)
        .then(response => {
          console.log(response);
          if (response.data.status === "success") {
            EventBus.$emit("passwordReset");
          } else {
            EventBus.$emit("failedResetPassword");
          }
        })
        .catch(error => {
          console.log("Error resetPassword: ", error);
          EventBus.$emit("failedResetPassword", error);
        });
    },
    forgotPassword(context, email, password) {
      return authService
        .resetPassword(email, password)
        .then(response => {
          console.log(response);
          if (
            response.data.status === "success" ||
            response.data.status === "unactivated"
          ) {
            return response.data.status;
          } else {
            EventBus.$emit("failedResetPassword");
          }
        })
        .catch(error => {
          console.log("Error resetPassword: ", error);
          EventBus.$emit("failedResetPassword", error);
        });
    },
    createPilotPassword(context, email, password) {
      return authService
        .createPilotPassword(email, password)
        .then(response => {
          console.log(response);
          if (response.data !== null) {
            EventBus.$emit("passwordReset");
          } else {
            EventBus.$emit("failedCreatePilotPassword");
          }
        })
        .catch(error => {
          console.log("Error createPilotPassword: ", error);
          EventBus.$emit("failedCreatePilotPassword", error);
        });
    },
    changePassword(context, password) {
      return authService
        .changePassword(password)
        .then(response => {
          console.log(response);
          if (response.data !== null) {
            EventBus.$emit("changedPassword");
          } else {
            EventBus.$emit("failedChangePassword");
          }
        })
        .catch(error => {
          console.log("Error changePassword: ", error);
          EventBus.$emit("failedChangePassword", error);
        });
    }
  },
  mutations: {
    updateField,

    logon(state) {
      state.loggedOn = true;
    },
    logout(state) {
      state.loggedOn = false;
      window.location.href = "/";
    },
    setUserProfile(state, payload) {
      console.log("setUser payload = ", payload);
      if (payload && payload.response.data !== "null") {
        state.loggedOn = true;
        var user = JSON.parse(payload.response.data);
        state.firstname = user.firstname;
        state.lastname = user.lastname;
        state.email = user.email;
        state.actions = user.activated;
        state.newsletter = user.newsletter;
        state.usertype = user.usertype;
        state.phone = user.phone;
        state.airport_id = user.airport_id;
        state.company = user.company;
        state.street = user.street;
        state.city = user.city;
        state.province = user.province;
        state.postalcode = user.postalcode;
        state.card_brand = user.card_brand;
        state.card_expire_month = user.card_expire_month;
        state.card_expire_year = user.card_expire_year;
        state.card_last4 = user.card_last4;
        state.plan_type = user.plan_type;
        state.cancelled = user.cancelled;
        state.coupon_used = user.coupon_used;
        state.plan_freq = user.plan_freq;
        state.quantity = user.quantity === undefined ? 0 : user.quantity;
        state.pilot_network = user.pilot_network;
        state.review_street = user.review_street || "";
        state.review_city = user.review_city || "";
        state.review_province = user.review_province || "";
        state.review_postalcode = user.review_postalcode || "";
        state.flight_schools = user.flight_schools || [];

        state.registered_on = new Date(
          user.registered_on.$date
        ).toLocaleDateString(
          window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US",
          dateOptions
        );
        EventBus.$emit("getUserProfile", state);
      }
    },
    setSubscription(state, payload) {
      if (!payload.response.data.error) {
        var subscription = JSON.parse(payload.response.data);
        if (subscription.error) {
          return;
        }
        state.current_period_start = new Date(
          subscription.current_period_start * 1000
        );
        state.current_period_start_date = state.current_period_start.toLocaleDateString(
          window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US",
          dateOptions
        );
        state.current_period_end = new Date(
          subscription.current_period_end * 1000
        );
        state.current_period_end_date = state.current_period_end.toLocaleDateString(
          window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US",
          dateOptions
        );
        EventBus.$emit("setSubscription");
      }
    }
  },
  getters: {
    getField
  }
};
